import { render, staticRenderFns } from "./MainAddressLocation.vue?vue&type=template&id=00c2c7b0&scoped=true&"
import script from "./MainAddressLocation.vue?vue&type=script&lang=js&"
export * from "./MainAddressLocation.vue?vue&type=script&lang=js&"
import style0 from "./MainAddressLocation.vue?vue&type=style&index=0&id=00c2c7b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c2c7b0",
  null
  
)

export default component.exports